<template>
  <div class="container-sm text-entry-control">
    <div class="text-entry-input-box" :class="{ focused: isFocused, 'has-error': reachedLimit }">
      <AutosizeTextarea
        v-model="value"
        :placeholder="$t('page_editor.text_entry.placeholder')"
        :limit="VALUE_LIMIT"
        @focus="isFocused = true"
        @keyup="handleSubmit()"
      />
    </div>
    <div
      v-if="reachedLimit"
      class="typography-caption typography-color-alert text-center pt-2"
    >
      {{ $t('viewer.quiz_item.text_entry_control.alerts.max_length') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'quiz-text-entry-control',

  props: {
    onSetSelectedOption: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      value: '',
      isFocused: false,
      VALUE_LIMIT: 30,
    };
  },

  computed: {
    reachedLimit() {
      return this.value.length >= this.VALUE_LIMIT;
    },
  },

  methods: {
    handleSubmit() {
      const option = {
        value: this.value,
      };

      this.onSetSelectedOption(option);
      this.isFocused = false;
    },
  },
};
</script>

<style lang="scss" scoped>
  .text-entry-control {
    padding-top: 40px;

    .text-entry-input-box {
      border-radius: 4px;
      background-color: #ffffff;
      border: solid 1px #cccccc;
      padding: 15px 16px;
      line-height: 18px;
      transition: border-color .5s ease, color .5s ease;

      &.focused {
        border: solid 1px #999999;
      }

      &.has-error {
        border: solid 1px #e91e63;
      }

      textarea {
        width: 100%;
        font-size: 16px;
        font-weight: 400;
        line-height: 1.29;
        color: rgba(0, 0, 0, 0.87);
        outline: none;
        padding: 0;
        border: none;
        vertical-align: top;
        user-select: auto !important;

        &::placeholder {
          color: rgba(0, 0, 0, 0.26);
        }
      }
    }

    .text-entry-btn-area {
      padding-top: 20px;
      margin-bottom: 16px;

      button {
        min-width: 120px;
      }
    }
  }
</style>
